export default __webpack_public_path__ + "static/media/casino-forgot-pass.ccbe644c.png";